const en = {
  "bankNumber": "CLABE no válida",
  "dateRange": "Rango de fechas no válido",
  "dateValid": "Fecha invalida",
  "email": "Email no válido",
  "fakeEmail": "Email no válido",
  "fakePhoneNumber": "Número de teléfono no válido",
  "emailNoAt": "El email debe contener @",
  "emailMultipleAt": "El email no puede contener múltiples @",
  "emailAtPosition": "El email no puede empezar o terminar con @",
  "emailSpaces": "El email no puede contener espacios",
  "emailControlChars": "El email contiene caracteres no válidos",
  "emailNonAscii": "El email contiene caracteres no válidos",
  "emailLocalPartLength": "La parte del usuario del email debe tener entre 1 y 64 caracteres",
  "emailConsecutiveDots": "El email no puede contener puntos consecutivos (..)",
  "gmailLengthInvalid": "El usuario de Gmail debe tener entre 6 y 30 caracteres",
  "emailInvalidChars": "El usuario del email solo puede contener letras, números y puntos",
  "max": "El valor máximo es {max}",
  "maxLength": "La longitud máxima es {maxLength}",
  "min": "El valor mínimo es {min}",
  "minLength": "La longitud mínima es {minLength}",
  "notSameAs": "Los campos no coinciden",
  "number": "No es un número",
  "pattern": "Formato incorrecto",
  "required": "Campo obligatorio",
  "sameAs": "Los campos no coinciden",
  "string": "Carácter no válido",
  "url": "Invalid url",
  "strictEmail": "Email no válido",
  "gmailEmail": "Email no válido",
  "notNumber": "No debe ser un número",
  "notDigits": "No debe contener solo dígitos"
};


export default en;
